import * as Yup from "yup";

const ChildStep8Schema = Yup.object().shape({
  priorityAccessId: Yup.number().required("Required"),
});

export default ChildStep8Schema;
